// Kept in step with mobile useSpeakNavigation and Chat.practice_vocab_default_for.
// Today manual vocab and custom conversations never reach this gate (their flows
// submit the form directly), so a future caller for those flows must pass the
// manualVocab / customConversation flags or the dialog would show.
function shouldShowPhraseIdeas({ enabled, setting, level, category = '', topicKey, subtopic, manualVocab, customConversation }) {
  if (!enabled || manualVocab || customConversation) return false;
  if (/^(grammar|vocab)(_|\/|$)/.test(category) || category === 'custom_conversation') return false;
  if ([topicKey, subtopic].includes('custom_conversation')) return false;
  if (category === 'roleplay' && [topicKey, subtopic].includes('custom_topic')) return false;
  if (category === 'debate' && [topicKey, subtopic].includes('custom_chose_a_topic')) return false;
  if (category === 'chat_about_anything' && [topicKey, subtopic].includes('free_chat')) return false;
  if (setting == null) return category === 'roleplay' && ['beginner', 'basic'].includes(level);
  return [true, 'true', 1, '1'].includes(setting);
}

function promptItemsFor({ chatKey, category, subtopic, topicKey }) {
  if (chatKey) return chatKey.split('.');
  // Mobile sends two entries for a subcategory leaf, three for a nested topic.
  return subtopic ? [category, subtopic, topicKey] : [category, topicKey];
}

function flashcardPayload({ phrase, translation }, language) {
  return { flashcard: { front: phrase, back: translation || '', language, tags: ['phrase'] } };
}

function phraseResult(data) {
  // Failures arrive as { phrases: { error } }, or as a bare string when the AI
  // client returned an error body (Stream::PreChatPracticeService).
  if (data?.phrases?.error || typeof data?.phrases === 'string' || data?.status === 'failed') return { error: 'phrases_failed' };
  if (Array.isArray(data?.phrases)) {
    // One row per card: a repeated phrase and translation would share a save button.
    const seen = new Set();
    const phrases = data.phrases.filter(p => {
      if (typeof p?.phrase !== 'string' || !p.phrase.trim()) return false;
      const key = JSON.stringify([p.phrase, p.translation || '']);
      return !seen.has(key) && seen.add(key);
    });
    return phrases.length ? { phrases } : { error: 'phrases_failed' };
  }
  return data?.status === 'complete' ? { error: 'phrases_failed' } : null;
}

function retryAfterMs(value, now = Date.now()) {
  if (value == null || value === '') return 5000;
  const seconds = Number(value);
  if (Number.isFinite(seconds) && seconds >= 0) return seconds * 1000;
  const date = Date.parse(value);
  return Number.isFinite(date) ? Math.max(0, date - now) : 5000;
}

module.exports = { shouldShowPhraseIdeas, promptItemsFor, flashcardPayload, phraseResult, retryAfterMs };
